import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Toaster } from 'sonner';
import App from './App';
import './styles.css';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
    <Toaster richColors position="top-center" />
  </StrictMode>,
);

// v3.9 removes the old service-worker cache so website and Android Preview
// always load the latest deployed interface instead of a stale JavaScript bundle.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((registration) => registration.unregister()));

      if ('caches' in window) {
        const keys = await caches.keys();
        await Promise.all(keys.map((key) => caches.delete(key)));
      }

      if (navigator.serviceWorker.controller && !sessionStorage.getItem('scan-view-cache-reset-v39')) {
        sessionStorage.setItem('scan-view-cache-reset-v39', '1');
        window.location.reload();
      }
    } catch (error) {
      console.warn('Could not clear an older app cache', error);
    }
  });
}
